var styles = {"row":"styles_row__2jwKg flex col-12 md-col-7 mx-auto clearfix","placement-modal":"styles_placement-modal__yrEtY","placementModal":"styles_placement-modal__yrEtY","graphic":"styles_graphic__cex2- left","copy":"styles_copy__2YjC1 left","icon":"styles_icon__3JzOi","link":"styles_link__1niEA"};

export default styles;
//# sourceMappingURL=styles.css.js.map
